define('home/views/ProfileCardCollectionView',[
    'backbone',

    'core/bus',

    'home/views/common/FetchableCollectionView',
    'home/views/ProfileCardCommentsView',
    'home/views/ProfileCardFavoriteView',
    'home/views/ProfileCardCreateDiscussionView',

    'home/mixins/withViewFeedTracking',
], function (
    Backbone,

    bus,

    FetchableCollectionView,
    ProfileCardCommentsView,
    ProfileCardFavoriteView,
    ProfileCardCreateDiscussionView,

    withViewFeedTracking
) {
    'use strict';

    var ProfileCardCollectionView = FetchableCollectionView.extend({
        initialize: function () {
            FetchableCollectionView.prototype.initialize.apply(this, arguments);
            this.listenToOnce(this, 'showFirstItem', function () {
                bus.trigger('showFirstCard', 'profile');
            });
        },

        itemView: function (options) {
            switch (options.model.get('verb')) {
            case 'reply':
            case 'post':
                return new ProfileCardCommentsView(options);
            case 'favorite':
                return new ProfileCardFavoriteView(options);
            case 'create':
                return new ProfileCardCreateDiscussionView(options);
            default:
                return new Backbone.View();
            }
        },

        emptyViewOptions: function () {
            return {
                model: this.options.user,
            };
        },
    });

    withViewFeedTracking.call(ProfileCardCollectionView.prototype);

    return ProfileCardCollectionView;
});

